// export const API = 'https://onemin-staging.herokuapp.com/api/';
//export const PRINTING_SERVER = "";

function oldProdToNew(endpoint) {
    return endpoint.replace("onemin-prod.herokuapp.com", "backend-prod.oneminorder.hu");
}

function getProtocol() {
    var url = window.location.href;
    var arr = url.split("/");
    let protocol = arr[0] || "http:";
    if (["http:", "https:"].indexOf(protocol) == -1) {
        protocol = "http:";
    }
    return protocol;
}

export const API = (() => {
    let endpoint = localStorage.getItem("server_api");
    if (!endpoint || endpoint == "")
        // endpoint = 'http://192.168.0.211:8080/api/';
        // endpoint = 'http://192.168.0.241:8080/api/';
        // endpoint = 'http://127.0.0.1:8080/api/';
        endpoint = getProtocol() + "//onemin-prod.herokuapp.com/api/";
    return oldProdToNew(endpoint);
})();

export const PRINTING_SERVER = (() => {
    let endpoint = localStorage.getItem("server_print");
    if (!endpoint || endpoint == "") endpoint = getProtocol() + "//onemin-prod.herokuapp.com/";

    return oldProdToNew(endpoint);
})();

// it can be only staging or prod
export const PROD_API = (() => {
    let endpoint = localStorage.getItem("server_prod_api");
    if (!endpoint || endpoint == "") endpoint = getProtocol() + "//onemin-prod.herokuapp.com/api/";
    // endpoint = getProtocol()+'//localhost:3000/api/';
    return oldProdToNew(endpoint);
})();

export const getLocalIP = function (callback) {
    window.RTCPeerConnection =
        window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection; //compatibility for Firefox and chrome
    var pc = new RTCPeerConnection({ iceServers: [] }),
        noop = function () {};
    if (typeof pc.createDataChannel === "undefined") return;

    pc.createDataChannel(""); //create a bogus data channel
    pc.createOffer(pc.setLocalDescription.bind(pc), noop); // create offer and set local description
    pc.onicecandidate = function (ice) {
        if (ice && ice.candidate && ice.candidate.candidate) {
            var myIP;
            var ipList = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(
                ice.candidate.candidate
            );
            if (ipList && ipList.length > 0) {
                myIP = ipList[1];
            }
            callback(myIP);
            pc.onicecandidate = noop;
        }
    };
};

export const NOT_EDITABLE_PAYMENT_METHOD = [
    "simplepay",
    "barion",
    "szep_kartya_web",
    "credit_card_external",
    "szep_kartya_external",
    "mkb_szep_web",
    "kah_szep_web",
    "pizzagyar_pizza_coupon",
    "other",
    "total",
    "invoice",
    "discount",
    "archived",
    "mkb_szep_web",
    "kah_szep_web",
    "card_online",
    "szep_kartya_online"
];

export const NOT_EDITABLE_ORDER_PAYMENTS = [
    "simplepay",
    "barion",
    "szep_kartya_web",
    "credit_card_external",
    "szep_kartya_external",
    "mkb_szep_web",
    "kah_szep_web",
    "pizzagyar_pizza_coupon",
    "other",
    "total",
    "invoice",
    "discount",
    "archived",
    "mkb_szep_web",
    "kah_szep_web",
    "balance"
];

/* take_way */
export const EDITABLE_PAYMENT_METHODS = {
    sit_in: {
        cash_sit_in: "Kp (beülős)",
        credit_card_sit_in: "Bk (beülős)",
        erzsebet_plusz: "Erzsébet plusz",
        ticket_express: "Ticket E",
        sodexo: "Sodexo",
        cash: "Készpénz",
        erzsebet: "Erzsébet utalvány",
        szep_kartya_sit_in: "Szk(beülős)",
        mkb_szep_sit_in: "MKB Szk(beülős)",
        otp_szep_sit_in: "OTP Szk(beülős)",
        kah_szep_sit_in: "K&H Szk(beülős)",
        balance: "Számlára"
    },
    take_away: {
        cash_sit_in: "Kp (beülős)",
        credit_card_sit_in: "Bk (beülős)",
        erzsebet_plusz: "Erzsébet plusz",
        ticket_express: "Ticket E",
        sodexo: "Sodexo",
        cash: "Készpénz",
        erzsebet: "Erzsébet utalvány",
        szep_kartya_sit_in: "Szk(beülős)",
        mkb_szep_sit_in: "MKB Szk(beülős)",
        otp_szep_sit_in: "OTP Szk(beülős)",
        kah_szep_sit_in: "K&H Szk(beülős)",
        balance: "Számlára"
    },
    phone: {
        cash_on_delivery: "Kp",
        credit_card_on_delivery: "Bk futár",
        szep_kartya: "Szk futár",
        erzsebet_utalvany: "Erzsébet u",
        ticket_express: "Ticket E",
        sodexo: "Sodexo",
        erzsebet_plusz: "Erzsébet plusz",
        erzsebet: "Erzsébet utalvány (régi)",
        cash_phone: "Kp (telefonos)",
        credit_card_phone: "Bankkártya(telefon)",
        szep_kartya_phone: "Szk(telefon)",
        mkb_szep_phone: "MKB Szk(telefon)",
        otp_szep_phone: "OTP Szk(telefon)",
        kah_szep_phone: "K&H Szk(telefon)",
        utalvany: "Utalvány",
        balance: "Számlára"
    }
};

export const PAYMENT_METHODS = (() => {
    return {
        cash_on_delivery: "Kp",
        credit_card_on_delivery: "Bk futár",
        cash_sit_in: "Kp (beülős)",
        credit_card_sit_in: "Bk (beülős)",
        szep_kartya: "Szk futár",
        erzsebet_utalvany: "Erzsébet u",
        ticket_express: "Ticket E",
        sodexo: "Sodexo",
        simplepay: "Simplepay (fizetve!)",
        erzsebet_plusz: "Erzsébet plusz",
        erzsebet_plusz_online: "Erzsébet plusz online",
        szep_kartya_web: "Szk online (fizetve!)",
        credit_card_external: "Bk (fizetve)",
        szep_kartya_external: "Szk (fizetve)",
        barion: "Barion",
        card: "Bankkártya" /* Futár összesitő miatt: card, cash, total */,
        cash: "Készpénz",
        erzsebet: "Erzsébet utalvány",
        other: "Egyéb",
        total: "Összesen",
        invoice: "Számla",
        pizzagyar_pizza_coupon: "Pizzgyár Pizzakupon",
        discount: "Kedvezmény",
        cash_phone: "Kp (telefonos)",
        credit_card_phone: "Bankkártya(telefon)",
        szep_kartya_phone: "Szk(telefon)",
        mkb_szep_phone: "MKB Szk(telefon)",
        otp_szep_phone: "OTP Szk(telefon)",
        kah_szep_phone: "K&H Szk(telefon)",
        szep_kartya_sit_in: "Szk(beülős)",
        mkb_szep_sit_in: "MKB Szk(beülős)",
        otp_szep_sit_in: "OTP Szk(beülős)",
        kah_szep_sit_in: "K&H Szk(beülős)",
        mkb_szep_on_delivery: "MKB Szk(futár)",
        otp_szep_on_delivery: "OTP Szk(futár)",
        kah_szep_on_delivery: "K&H Szk(futár)",
        utalvany: "Utalvány",
        archived: "Sztornó",
        mkb_szep_web: "MKB Szk online (fizetve)",
        kah_szep_web: "K&H Szk online (fizetve)",
        card_online: "Bankkártya online",
        szep_kartya_online: "Szépkártya online",
        tip: "Szervízdíj",
        balance: "Számlára"
    };
})();

var userAgent = navigator.userAgent.toLowerCase();

export const defaultSettings = {
    fullprint_courier_num: 1,
    fullprint_kitchen_num: 1,
    checkout_courier_num: 0,
    checkout_kitchen_num: 0,
    cartsaving_kitchen_num: 1,
    phoneorder_courier_num: 1,
    phoneorder_kitchen_num: 1,
    kitchen_done_num: 0,
    courier_address_assign_num: 1,
    courier_start_num: 0,
    oneClickCategories: [],
    phone_oneClickCategories: [],
    default_printing_method: userAgent.indexOf(" electron/") > -1 ? "client" : "browser", // It can be 'client', 'server'
    courier_orders_qstat: "all", // It can be 'done', 'all'
    quicksearch: 0,
    quicksearch_buttons: [],
    menu_billing: 0,
    sound_courier: 0,
    sound_kitchenview: 0,
    time: { start_time: { hour: 0, minute: 0 }, end_time: { hour: 0, minute: 0 } },
    browser_print_auto_close: 1,
    browser_print_win_width: 100,
    browser_print_win_height: 100,
    browser_print_margin_top: "0.5in",
    browser_print_margin_bottom: "0.10in",
    browser_print_margin_left: "0.05in",
    browser_print_margin_right: "0.05in",
    browser_print_padding_top: "0",
    browser_print_padding_bottom: "0",
    browser_print_padding_left: "0",
    browser_print_padding_right: "0",
    enable_phone_autocomplete: 0,
    default_region: "",
    browser_print_font_size: 10,
    print_vat: 0,
    kitchen_block_product_cat_order_1: "",
    kitchen_block_product_cat_order_2: "",
    kitchen_block_product_cat_order_3: "",
    kitchen_block_product_cat_order_4: "",
    kitchen_block_product_cat_order_5: "",
    enable_service_fee: 0,
    disable_counter_fullprint: 0,
    enable_cart_item_duplicate: 0,
    enable_message_on_payment: 0,
    daily_print_size: "small",
    enable_kitchenview_admin_userinfo: 0,
    courier_auto_start_finish: 0,
    service_fee_calculating_type: 0,
    enable_lct_courier: 0,
    enable_cart_groupping: 0,
    back_to_table_1: 0,
    back_to_category_1: 0,
    enable_no_delivered_highlight: 0,
    order_sort_type: "date",
    enable_search_focus: 1,
    enable_table_move_if_not_empty: 0,
    enable_product_name_cut: 0,
    enable_product_name_cut_char_num: 34,
    back_to_product_after_cart_add: 0,
    default_payment_method_phone_order: "",
    kitchen_product_group: "false"
};

export const kitchenBlockColors = [
    { name: "Lila", color: "#8e44ad" },
    { name: "Kék", color: "#2980b9" },
    { name: "Türkizkék", color: "#4fa7b7" },
    { name: "Narancs", color: "#d35400" },
    { name: "Sötétkék", color: "#2C3E66" }
];

export const foodStatuses = {
    queued: "Várakozás",
    in_progress: "Folyamatban",
    done: "Elkészült"
};

export const foodStatusesClass = {
    queued: "just_ordered",
    in_progress: "in_progress",
    done: "is_done"
};

export const printError = {
    UNKNOWN: "Ismeretlen hiba nyomtatás közben",
    PRINTERNOTEXISTS: "Nem létező nyomtató",
    NOPRINTER: "Nem található megfelelő nyomtató",
    PRINTERBUSY: "A nyomtató foglalt, nem válaszol",
    TIMEOUT: "Nyomtatás közben időtúllépés (válasz vagy hálózati probléma)"
};

export const roleInUse = () => {
    let roles = JSON.parse(localStorage.getItem("roles"));
    for (let i in roles) {
        if (roles && i.includes("_role") && roles[i]) {
            return true;
        }
        if ((i == "manager" || i == "manager_with_pin") && roles[i]) {
            return true;
        }
    }
    return false;
};
export const permInUse = () => {
    let roles = JSON.parse(localStorage.getItem("roles"));
    for (let i in roles) {
        if (roles && i.startsWith("perm_") && roles[i]) {
            return true;
        }
    }
    return false;
};

export const getNumberRoleValue = (role_name) => {
    try {
        let roles = JSON.parse(localStorage.getItem("roles"));

        if (roles && typeof roles[role_name] !== "undefined" && roles[role_name] != "") {
            return roles[role_name];
        }
    } catch (e) {}
    return;
};

export const hasRole = (role_name) => {
    try {
        let roles = JSON.parse(localStorage.getItem("roles"));

        if (roles && typeof roles[role_name] !== "undefined" && roles[role_name]) {
            return true;
        }
    } catch (e) {}
    return false;
};

export const hasPIN = () => {
    let roles = JSON.parse(localStorage.getItem("roles"));

    if (roles && typeof roles["perm_pin"] !== "undefined" && roles["perm_pin"] != "") {
        return true;
    }
    return false;
};

export const checkPIN = (pin) => {
    let roles = JSON.parse(localStorage.getItem("roles"));

    /* Legacy */

    if (roles && typeof roles["perm_pin"] !== "undefined" && roles["perm_pin"].length > 0) {
        return roles["perm_pin"] == pin;
    }

    /* Legacy */
    if (roles && typeof roles["pin"] !== "undefined" && roles["pin"] == pin) {
        return true;
    }
    return false;
};

export const acceptedZone = () => {
    return localStorage.getItem("zone") || 0;
};

export const defaultHome = () => {
    let defaultHome = "";
    let roles = JSON.parse(localStorage.getItem("roles"));

    if (Object.keys(roles).length > 0) {
        defaultHome = "/orders/";
    }
    if (roles["perm_orders"] != undefined && roles["perm_orders"]) {
        defaultHome = "/orders/";
    } else if (roles["perm_table"] != undefined && roles["perm_table"]) {
        defaultHome = "/tables/";
    } else if (roles["perm_phone"] != undefined && roles["perm_phone"]) {
        defaultHome = "/phone-order/";
    } else if (roles["perm_courier"] != undefined && roles["perm_courier"]) {
        defaultHome = "/courier/";
    }

    return defaultHome;
};

export const setCookie = (name, value, expireinday) => {
    var expires = "";
    if (typeof expireinday !== "undefined") {
        let d = new Date();
        d.setTime(d.getTime() + expireinday * 24 * 60 * 60 * 1000);
        expires = "expires=" + d.toUTCString();
    }
    var hostname = document.location.hostname;
    var hostnames = hostname.split(".");
    if (hostnames.length > 1) {
        var hostname = hostnames[hostnames.length - 2] + "." + hostnames[hostnames.length - 1];
    }
    document.cookie = name + "=" + value + "; " + expires + ";domain=." + hostname;
};

export const getCookie = (varname) => {
    var name = varname + "=";
    var cookievars = document.cookie.split(";");
    for (var i = 0; i < cookievars.length; i++) {
        let c = cookievars[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
};
export const isIOS = () => {
    var standalone = window.navigator.standalone,
        userAgent = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test(userAgent),
        ios = /iphone|ipod|ipad/.test(userAgent);

    if (ios) {
        /*  if ( !standalone && safari ) {
            //browser
        } else if ( standalone && !safari ) {
            //standalone
        } else if ( !standalone && !safari ) {
            //uiwebview
        }; */
        return true;
    } else {
        //not iOS
        return false;
    }
};

export const isElectron = () => {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf(" electron/") > -1) {
        return true;
    }
    return false;
};

export const removeAccent = (str) => {
    // o-ó ö-ő u-ú ü-ű
    let s = str.replace(/ó|Ó/g, "o");
    s = s.replace(/ő|Ő/g, "ö");
    s = s.replace(/ú|Ú/g, "u");
    s = s.replace(/ű|Ű/g, "ü");
    s = s.replace(/í|Í/g, "i");
    s = s.replace(/á|Á/g, "a");
    return s;
};

export const getPlatformLabel = (platform) => {
    let platforms = {
        sit_in: "Beülős",
        take_way: "Elviteles",
        phone: "Telefonos"
    };
    return platforms[platform] || platform;
};



// WEBPACK FOOTER //
// ./src/services/Common.js